// extracted by mini-css-extract-plugin
export default {"leave-encash-header":"LeaveEncashmentReport_leave-encash-header__7RUME","divider":"LeaveEncashmentReport_divider__3GXv9"};